exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._533XM {\n  padding: 20px 25px;\n}\n", ""]);

// Exports
exports.locals = {
	"copyright": "_533XM"
};